var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"success-dialog"},[_c('div',{staticClass:"success-dialog-main"},[_c('div',{staticClass:"success-btn",on:{"click":_vm.hide}},[_c('span',[_vm._v("我知道啦")])])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }